import { withInstall, withNoopInstall } from "@xplus/utils/with-install";
import popover from "./src/popover.vue";
import tableImage from "./src/table-image.vue";
export const xPopover = withInstall(popover, { tableImage });
export const xTableImage = withNoopInstall(tableImage);
export default xPopover;
export * from "./src/popover";
export * from "./src/table-image";
